import { useEffect, useState } from 'react'
import { getRelatedProducts } from 'src/services/linx-api'
import { RelatedProductResponse } from 'src/services/linx-api/dtos'
import { getShowCase } from 'src/services/marketplace-api/vitrines'
import { isMobileDevice } from 'src/util/device-type'
import { DeviceType, LinxShowcaseType } from '../types'

export const useProductShowcases = (
  name: string,
  categoryName?: string,
  productId?: number
) => {
  const [showcases, setShowcases] = useState<RelatedProductResponse>({
    top: [],
    middle: [],
    bottom: [],
  })

  useEffect(() => {
    const source = isMobileDevice() ? DeviceType.MOBILE : DeviceType.DESKTOP

    if (name === LinxShowcaseType.SEARCH || name === LinxShowcaseType.HOME) {
      getShowCase(source, name).then((showcases) => setShowcases(showcases))
      return
    }

    getRelatedProducts(source, name, productId, categoryName).then(
      (showcases) => setShowcases(showcases)
    )
  }, [name, productId, categoryName])

  return {
    showcaseTop: showcases?.top,
    showcaseMiddle: showcases?.middle,
    showcaseBottom: showcases?.bottom,
  }
}
